/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable arrow-body-style */
/* eslint-disable no-script-url */
/* eslint-disable react/button-has-type */
import React from 'react';
import './viewelement.css';
import { useLocation } from 'react-router';

const ViewListing = () => {
  const location = useLocation();
  const datas = location?.state;
  console.log(datas, 'location?.state');

  return (
    <>
      <div className="container">
        <div className="main-body">
          <div className="row gutters-sm">
            <div className="col-md-12">
              <div className="card mb-3">
                <div className="card-body">
                  <div className="row" style={{ gap: '12px' }}>
                    <div className="row" style={{ gap: '12px' }}>
                      <h2 className="fw-bold">Listings Details</h2>
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Address</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.address}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Name</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.name}</div>
                        </div>
                      </div>
                       
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Agent Commission</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.agent_commission}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Bathroom</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.bathroom}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Bedroom</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.bedroom}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Commercial</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.commercial}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div className="width">
                          <h6 className="mb-0">Land</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.land}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div className="width">
                          <h6 className="mb-0">Listing</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.listing}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Lot Size</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.lot_size}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Neighborhoods</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.neighborhoods}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Off Market</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.offmarket}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">price</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.price}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Rentals</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.rentals}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Square Feet Size</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.square_feet_size}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Request Email</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.request_email}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Schedule Email</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.schedule_email}</div>
                        </div>
                      </div>
                      <hr/>
                      {datas?.photos?.map((item, index) => {
                        return (
                          <>
                            <div className="col-sm-12 columns" key={index}>
                               <div><img width={"40%"} style={{borderRadius:"60%"}} src={`https://fengshuiapi.devssh.xyz${item?.name}`} alt='dd'/></div>
                            </div>
                            <hr />
                          </>
                        );
                      })}
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Description</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.description}</div>
                        </div>
                      </div>
                     
                      {/* {datas?.listing_extra_service_prices?.map((item, index) => {
                        return (
                          <>
                            <div className="col-sm-12 columns" key={index}>
                              <div>
                                <h6 className="mb-0">Listing Extra Service Prices</h6>
                              </div>
                              <div className="width">
                                <div className="col-sm-12 text-secondary">{item?.name}</div>
                              </div>
                            </div>
                            <hr />
                          </>
                        );
                      })}
                      {datas?.listing_images?.map((item, index) => {
                        return (
                          <>
                            <div className="col-sm-12 columns" key={index}>
                              <div>
                                <h6 className="mb-0">Listing Images</h6>
                              </div>
                              <div className="width">
                                <div className="col-sm-12 text-secondary">
                                  <img src={item?.image} alt="Images" style={{ width: '80px' , height:'80px' , borderRadius:'50%' }} />
                                </div>
                              </div>
                            </div>
                            <hr />
                          </>
                        );
                      })} */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewListing;
